import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import '../node_modules/plyr/dist/plyr.css';
import App from './App';
import Config from './config';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';

const msalInstance = new PublicClientApplication(Config.auth);

const initializeApp = async () => {
  await msalInstance.initialize();
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) msalInstance.setActiveAccount(accounts[0]);

  // Default to using the first account if no account is active on page load
  const container = document.getElementById('root');
  const root = ReactDOM.createRoot(container!);

  root.render(<App msalInstance={msalInstance} />);
};

initializeApp();

serviceWorker.unregister();
